import React, { useState, useEffect } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import CloseBtn                       from 'assets/icons/Close.svg';
import ListOptionsBtn       from 'assets/icons/List Options.svg';

export function ClaimFilters(props) {
  const handleClose       = () => setShow(false);
  const handleShow        = () => setShow(true);
  const [show, setShow]   = useState(false);

  // Selecting status
    const [status, setStatus] = useState('');

    const selectStatus = (value) => {
      setStatus(status !== value ? value : '');
    }

    const statuses = [
      { name: 'Pending Submission', value: 'not_submitted' }, // Has value of not_submitted, under_review & draft.
      { name: 'Approved',           value: 'approved' },
      { name: 'Rejected',           value: 'rejected' },
      { name: 'Pending Approval',   value: 'pending_approval' } // Has value of pending & under_approval_review.
    ];

    const statusButtons = statuses.map((hash, index) => {
      const btnColor = status === hash.value ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey'

      return(
        <button key={ index } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectStatus(hash.value) }>{ hash.name }</button>
      )
    });
  // Selecting status
    const [category, setCategory] = useState('');

    const selectCategory = (value) => {
      setCategory(category !== value ? value : '');
    }

    const categories = [
      { name: 'Medical',            value: 'medical' },
      { name: 'Optical',            value: 'optical' }
    ];

    const categoryButtons = categories.map((hash, index) => {
      const btnColor = category === hash.value ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey'

      return(
        <button key={ index } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectCategory(hash.value) }>{ hash.name }</button>
      )
    });

  // Selecting amounts
    const [amount, setAmount] = useState('');

    const selectAmount = (value) => {
      setAmount(amount !== value ? value : '');
    }

    const amounts = [
      { name: 'MYR 0.00 - MYR 50.00', value: '0 to 50' },
      { name: 'MYR 50.01 - MYR 100.00', value: '50.01 to 100' },
      { name: 'MYR 100.01 - MYR 200.00', value: '100.01 to 200' },
      { name: 'MYR 200.01 - MYR 300.00', value: '200.01 to 300' },
      { name: 'MYR 300.01 - MYR 500.00', value: '300.01 to 500' },
      { name: 'MYR 500.01 - MYR 1000.00', value: '500.01 to 1000' },
      { name: 'MYR 1000.01 and above', value: '1000.01 and above' }
    ];

    const amountButtons = amounts.map((hash, index) => {
      const btnColor = amount === hash.value ? 'btn-outline-danger bg-faintred' : 'btn-outline-disabledgrey'

      return(
        <button key={ index } className={ "btn rounded-pill px-6 py-3 mr-3 mb-3 " + btnColor } onClick={() => selectAmount(hash.value) }>{ hash.name }</button>
      )
    });

  // Apply Button
    const [applyBtn, setApplyBtn] = useState(<span></span>);

    useEffect(() => {
      const applyFilters = () => {
        props.changeFilters(status, amount, category);
        setShow(false);
      }

      setApplyBtn(
        <button className="btn rounded-pill btn-danger w-em-26 py-3" onClick={() => applyFilters() }>Apply</button>
      );
    }, [status, amount, category]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <img src={ ListOptionsBtn } alt="list-options-btn" className="mr-4 clickable w-em-7" onClick={ handleShow } />

      <Modal show={ show } onHide={ handleClose } keyboard={ false } dialogClassName="modal-70w" centered>
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>

          <button type="button" className="close" onClick={ handleClose }>
            <img src={ CloseBtn } alt="modal-close" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <h6 className="modal-section-header px-4 py-3 my-6">Status</h6>
            { statusButtons }
            <h6 className="modal-section-header px-4 py-3 my-6">Category</h6>
            { categoryButtons }
            <h6 className="modal-section-header px-4 py-3 my-6">Bill Amount</h6>
            { amountButtons }

            <div className="mt-8 text-center">
              { applyBtn }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}